export default "patients"; 
